import { beginUiOverlay, endUiOverlay } from '../../core/AppStateManager';
const escapeHandlers = new Map();
const backdropHandlers = new Map();
function ensureBackdrop() {
    let host = document.getElementById('modal-backdrop');
    if (!host) {
        host = document.createElement('div');
        host.id = 'modal-backdrop';
        host.className = 'oe-modal-backdrop';
        document.body.appendChild(host);
    }
    return host;
}
export function closeModal(id) {
    const existing = document.getElementById(id);
    if (existing) {
        existing.remove();
        endUiOverlay();
    }
    const host = document.getElementById('modal-backdrop');
    const escapeHandler = escapeHandlers.get(id);
    if (escapeHandler) {
        window.removeEventListener('keydown', escapeHandler);
        escapeHandlers.delete(id);
    }
    const backdropHandler = backdropHandlers.get(id);
    if (backdropHandler && host) {
        host.removeEventListener('click', backdropHandler);
        backdropHandlers.delete(id);
    }
    if (host && host.children.length === 0) {
        host.remove();
    }
}
export function openModal(options, builder) {
    var _a, _b;
    const host = ensureBackdrop();
    const existing = document.getElementById(options.id);
    const modal = existing !== null && existing !== void 0 ? existing : document.createElement('div');
    const wasExisting = Boolean(existing);
    if (!wasExisting) {
        beginUiOverlay({ keepBlocked: options.keepBlocked });
    }
    modal.id = options.id;
    modal.className = 'oe-modal';
    modal.innerHTML = '';
    if (options.width) {
        modal.style.width = `${options.width}px`;
    }
    const header = document.createElement('div');
    header.className = 'oe-modal__header';
    header.innerText = options.title;
    modal.appendChild(header);
    const closeButton = document.createElement('button');
    closeButton.type = 'button';
    closeButton.className = 'oe-modal__close';
    closeButton.innerText = '×';
    closeButton.addEventListener('click', () => {
        var _a;
        closeModal(options.id);
        (_a = options.onClose) === null || _a === void 0 ? void 0 : _a.call(options);
    });
    modal.appendChild(closeButton);
    const content = document.createElement('div');
    content.className = 'oe-modal__content';
    modal.appendChild(content);
    builder(content);
    if (!wasExisting) {
        host.appendChild(modal);
    }
    const closeOnEscape = (_a = options.closeOnEscape) !== null && _a !== void 0 ? _a : false;
    if (closeOnEscape && !escapeHandlers.has(options.id)) {
        const handler = (event) => {
            var _a;
            if (event.key === 'Escape') {
                closeModal(options.id);
                (_a = options.onClose) === null || _a === void 0 ? void 0 : _a.call(options);
            }
        };
        escapeHandlers.set(options.id, handler);
        window.addEventListener('keydown', handler);
    }
    const closeOnBackdrop = (_b = options.closeOnBackdrop) !== null && _b !== void 0 ? _b : false;
    if (closeOnBackdrop && !backdropHandlers.has(options.id)) {
        const handler = (event) => {
            var _a;
            if (event.target === host) {
                closeModal(options.id);
                (_a = options.onClose) === null || _a === void 0 ? void 0 : _a.call(options);
            }
        };
        backdropHandlers.set(options.id, handler);
        host.addEventListener('click', handler);
    }
}
